module.exports = __webpack_public_path__ + "static/media/text-size.126f7588.svg";